import React from 'react';
import PropTypes from 'prop-types';
import { propTypes as CakesPropTypes } from '@config/Validators/cake.validator';
import clsx from 'clsx';
import t from '@unicat/i18n/Translate';

import BackButton from '@unicat/UI/BackButton';
import { useStyles } from './styles';
import CakeImage from '@unicat/UI/CakeImage/CakeImage';
import { ReactComponent as PersonIcon } from '@assets/icons/person_purple.svg';
import { ReactComponent as PieceIcon } from '@assets/icons/piece_purple.svg';
import MostPopularCakes from '@unicat/UI/MostPopular/MostPopularCakes';
import { gallery } from '@config/Portfolio';
import StyledLinkButton from '@unicat/UI/StyledLinkButton';

const CakePageContent = ({ image }) => {
  const {
    id,
    cakeInfo: { cost, numOfPeople, numOfPieces, recipe, story },
  } = image;
  const classes = useStyles();

  return (
    <>
      <section className={classes.wrapper}>
        <BackButton />
        <div className={classes.content}>
          {/** image block */}
          <div className={clsx(classes.block, classes.image)}>
            <CakeImage image={image} />
          </div>
          {/** info block */}
          <div className={clsx(classes.block, classes.info)}>
            <h2 className={classes.cakeName}>
              {t('Cake')} &quot;{id}&quot;
            </h2>
            <p className={classes.price}>$ {t(cost)}</p>
            <p className={classes.cakeInfo}>
              <span>
                <PersonIcon aria-hidden={'true'} width={24} height={24} viewBox={'0 0 24 24'} /> {t(numOfPeople)}
              </span>
              <span>
                <PieceIcon aria-hidden={'true'} width={24} height={24} viewBox={'0 0 24 24'} /> {t(numOfPieces)}
              </span>
            </p>
            <p className={classes.recipe}>{t(recipe)}</p>
            {/** buy button */}
            <StyledLinkButton className={classes.buy}>
              <p>{t('Make an order')}</p>
            </StyledLinkButton>
          </div>
          <p className={classes.recipe}>{t(story)}</p>
        </div>
        {/*<span>{JSON.stringify(image, null, 2)}</span>*/}
        <MostPopularCakes popular={gallery} />
      </section>
    </>
  );
};

const imagePropTypes = { ...CakesPropTypes };
CakePageContent.propTypes = {
  image: PropTypes.shape(imagePropTypes).isRequired,
};

export default CakePageContent;
